import { render, staticRenderFns } from "./EmpPriorAuthAddRule.vue?vue&type=template&id=c37b07a8&"
import script from "./EmpPriorAuthAddRule.vue?vue&type=script&lang=js&"
export * from "./EmpPriorAuthAddRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports